/* eslint-disable no-restricted-imports */
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';

export function ProgressDialog({ isOpen, handleClose, isProcessing, progressMessage, progress }) {
  if (!isOpen) return null;

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth
      maxWidth='sm'
      PaperProps={{
        style: {
          borderRadius: 12,
        },
      }}
    >
      <DialogTitle>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography variant='h6' style={{ fontWeight: 600 }}>
            Progresso da Atualização
          </Typography>
          <Button onClick={handleClose} disabled={isProcessing} style={{ minWidth: 32 }}>
            <Close />
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box mb={3}>
          <Typography variant='body1' style={{ display: 'flex', alignItems: 'center' }}>
            <CircularProgress size={20} style={{ marginRight: 8 }} />
            {progressMessage}
          </Typography>
        </Box>
        <Box position='relative' mb={2}>
          <LinearProgress
            variant='determinate'
            value={progress || 0}
            color='primary'
            style={{
              height: 10,
              borderRadius: 5,
              backgroundColor: '#f0f0f0',
            }}
          />
          <Box
            position='absolute'
            top={0}
            left={0}
            right={0}
            bottom={0}
            display='flex'
            alignItems='center'
            justifyContent='center'
          >
            <Typography variant='caption' style={{ color: '#fff', fontWeight: 'bold' }}>
              {progress || 0}%
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
